import { Component, ViewChild, EventEmitter  } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog, MatPaginator, MatSort } from '@angular/material'; 
import { DataSourceGrid } from '../../../utils/data-source-grid.component';

@Component({
  selector: 'my-parametro-sucursal',
  templateUrl: './parametros-sucursal.component.html',
  styleUrls: [],
  providers: [generalService]
})

export class ParametroSucursalComponent {
  dataParametros: DataSourceGrid | null;
  displayedColumns = ['acciones', 'nombre', 'valor'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public idSucursal = this.dataService.id;
  public activeSucursal = this.dataService.isUpdate;
  public nombreSucursal = this.dataService.mensaje;
  public listaParametros: Array<any>;
  public nuevoParametro: FormGroup;
  public showForm: boolean = false;
  public buttonT: string;
  public param: any = {
    id: null,
    nombre: null,
    descrip: null,
    valor: null
  };

  constructor(private formBuilder: FormBuilder, 
              private _generalService: generalService, 
              public dialog: MatDialog, 
              public dataService: DataService) {
    this.listaParametros = new Array();
  }

  ngOnInit() {
    this.getParametros();
    this.buildFormulario();
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  getParametros(){
    let link = "Sucursal/consultaParametros/" + this.idSucursal; 

    this._generalService.metodoCall(link).subscribe(
      result => {
        this.listaParametros = JSON.parse(result);
        this.dataParametros = new DataSourceGrid(this.listaParametros, this.paginator, this.sort);
        if(this.listaParametros.length <= 0)
          { $(".mat-row").remove(".mat-row"); }
        },
      error => {  console.log(<any>error);  }
    );
  }

  buildFormulario() {
    this.nuevoParametro = this.formBuilder.group({
      nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(15)]),
      descripcion: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      valor: this.formBuilder.control(null, [Validators.required]),
    });
  }

  editParametro(edit, row) {
    this. showForm = true;
    this.buttonT = "Agregar";

    if(edit) {
      this.buttonT = "Actualizar";
      this.param.id = row.idParametro;
      this.param.nombre = row.nombreParametro;
      this.param.descrip = row.descripcionParametro;
      this.param.valor = row.valorParametro;

      this.nuevoParametro.controls['nombre'].setValue(this.param.nombre);
      this.nuevoParametro.controls['descripcion'].setValue(this.param.descrip);
      this.nuevoParametro.controls['valor'].setValue(this.param.valor);
    }
  }

  cancelParametro(){
    this.getParametros();
    this.showForm = false;
    this.param.id = null;
    this.param.nombre = null;
    this.param.descrip = null;
    this.param.valor = null;
    this.nuevoParametro.reset();
  }

  submitParametro() {
    let tipo = 'editar';
    let datosParametro = {
      nombreParametro: this.param.nombre,
      descripcionParametro: this.param.descrip,
      valorParametro: this.param.valor  };
    let metodo = 'Sucursal/insertarParametro/' + this.idSucursal;

    if (this.param.id != null) {
      metodo = 'Sucursal/actualizarParametro/' + this.param.id;
    }

    this._generalService.metodoCallParamsPutPost(tipo, datosParametro, metodo).subscribe(
      (result) => { 
        if (result != '') {
          this._generalService.toastCall(result); } 
        else {
          this.cancelParametro(); }
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      }
    ); 
  }

  deleteParametro(row) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.getParametros(); });

    this._generalService.modal(eliminarHttp, 'confirm',
                               `¿Desea eliminar el parametro ${row.nombreParametro}?`,
                               'Sucursal/eliminarParametro', row.idParametro);
  }
}



// WEBPACK FOOTER //
// ./src/app/compania/sucursales/parametros/parametros-sucursal.component.ts